// ABOUTME: Stimulus controller para visualização de gráficos de consultas agregadas.
// ABOUTME: Alterna visibilidade do painel e troca entre tipos de gráfico via Chartkick.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleButton", "chartPanel", "chartContainer", "chartTypeSelect"]
  static values = { chartData: Object }

  connect() {
    this.chartPanelTarget.hidden = true
  }

  toggle(event) {
    event.preventDefault()
    this.chartPanelTarget.hidden = !this.chartPanelTarget.hidden
  }

  chartTypeChanged() {
    const type = this.chartTypeSelectTarget.value
    const container = this.chartContainerTarget
    const data = this.chartDataValue

    container.replaceChildren()

    const chartDiv = document.createElement("div")
    chartDiv.id = `chart_${Date.now()}`
    container.appendChild(chartDiv)

    const chartTypes = { bar: "BarChart", line: "LineChart", pie: "PieChart" }
    const chartClass = chartTypes[type] || "BarChart"

    new Chartkick[chartClass](chartDiv, data)
  }
}
